import { Action, AnyAction, configureStore, ThunkAction, ThunkDispatch } from '@reduxjs/toolkit';
import { Observable } from 'rxjs';

import { AuthReducer } from 'features/auth/auth.slice';
import { CoreSliceReducer } from 'features/core/core.slice';
import { CrisSlice } from 'features/cris/cris.slice';
import { CrowdSliceReducer } from 'features/crowd/slice';
import { ExploreReducer } from 'features/explore/explore.slice';
import { MessagingReducer } from 'features/messaging/messaging.slice';
import { QaSliceReducer } from 'features/qa/slice';
import { ResolverSliceReducer } from 'features/resolver/slice';
import { SeamSlice } from 'features/seam/slice';
import { ToolsSlice } from 'features/tools/slice';
import { LoaderReducer } from 'features/top-loader/loader.slice';
import { TupleReducers } from 'features/tuples/tuple.slice';
import { userSlice } from 'features/user/user.slice';

export const store = configureStore({
    reducer: {
        auth: AuthReducer,
        core: CoreSliceReducer,
        cris: CrisSlice,
        crowd: CrowdSliceReducer,
        explore: ExploreReducer,
        loader: LoaderReducer,
        messaging: MessagingReducer,
        qa: QaSliceReducer,
        resolver: ResolverSliceReducer,
        seam: SeamSlice,
        tools: ToolsSlice,
        tuples: TupleReducers,
        users: userSlice.reducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = ThunkDispatch<RootState, unknown, AnyAction> & typeof store.dispatch;
export type AppStore = typeof store;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
// a couple more types tha are used a lot
export type ObservableThunk<T> = AppThunk<Observable<T>>;

// for some reason typescript is not detecting proper type for the store.dispatch() method
// so we just export it manually
export const dispatch = store.dispatch as AppDispatch;
